// MarketplaceFooter — Art 14a informational footer.
// Extracted from CountryReturn.jsx in the Phase-3 refactor.
import React from "react";
import { useTranslation } from "react-i18next";

export const MarketplaceFooter = ({ data }) => {
  const { t } = useTranslation();
  return (
  <div
    data-testid="marketplace-facilitated-footer"
    className="text-xs text-slate-500 dark:text-slate-400 bg-slate-50/80 dark:bg-slate-900/80 border border-slate-300 dark:border-slate-700 rounded-lg p-3 mb-4"
  >
    <div className="font-bold text-slate-900 dark:text-slate-50 mb-1">
      {t("ui.country_return.marketplace.title", { defaultValue: "Marketplace facilitated (informational only)" })}
    </div>
    <div className="tabular-nums">
      {t("ui.country_return.marketplace.gross", { defaultValue: "Gross" })}{" "}
      <span data-testid="marketplace-facilitated-gross" className="text-slate-900 dark:text-slate-50">
        {data.gross}
      </span>
      {" "}— {data.note}
    </div>
    <div className="text-[10px] text-slate-500 dark:text-slate-400 mt-1">
      {t("ui.country_return.marketplace.authority", { defaultValue: "Authority:" })} {data.authority}
    </div>
  </div>
);
};
